import React, { useMemo } from 'react';
import cx from 'classnames';
import './index.less';
import { Tooltip } from '@bedrock/components';

export const linkPattern = new RegExp('(?:https?|ftp|file)://[-A-Za-z0-9+&$@#/%?=~_|!:,.;\\[\\]]+(?<!@)', 'g');
const replaceLinksWithTags = (text) => {
  return text.replace(linkPattern, (match) => {
    let url = match.startsWith('www.') ? `http://${match}` : match;
    let target = ' target="_blank"';
    return `<a style="color: var(--primary-1)" href="${url}"${target}>${match}</a>`;
  });
}

export const validateLink = (value: string) => {
  const patternResult = value.match(linkPattern)?.[0];
  if (!patternResult) {
    return false;
  }
  return true;
}

type TextAreaShowProps = {
  value?: string;
  showLine?: number;
  className?: string;
  style?: React.CSSProperties;
  showTooltip?: boolean;
  /** 原生hover展示dom配置的title，在 showTooltip 为false时生效，默认true */
  showHoverTitle?: boolean;
  tooltipProps?: React.ComponentProps<typeof Tooltip>;
  linkDetector?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export default function TextAreaShow({
  value = '',
  showLine = 100,
  className,
  style,
  showTooltip = false,
  showHoverTitle = true,
  tooltipProps,
  linkDetector = false,
  ...otherProps
}: TextAreaShowProps) {
  const content = useMemo(() => {
    return value.split?.('\n').map((text: string, index: number) => {
      // 替换空格
      text = text.replace(/ /g, '\u00a0');
      return (
        <React.Fragment key={index}>
          {!linkDetector ? <span>{`${text}`}</span> :
            <span dangerouslySetInnerHTML={{ __html: replaceLinksWithTags(text) }}></span>}
          <br />
        </React.Fragment>
      );
    })
  }, [value])
  return (
    <div>
      <div
        {...otherProps}
        className={cx('sform-textarea-show', className)}
        title={!showTooltip ? (showHoverTitle ? value : undefined) : undefined}
        style={{
        ...style,
        WebkitLineClamp: showLine
        } as React.CSSProperties}
      >
        {
          showTooltip ? <Tooltip title={<div className="sform-textarea-show-tooltip-content">
            {content}
          </div>}
          {...tooltipProps}
        >
          <div>
              {content}
          </div>
          </Tooltip> : content
        }
      </div>
    </div>
    
  );
}
